<a class="dropdown-item pointer" (click)="resetUserStateSettings()">{{
  '::ResetViewSettings' | abpLocalization
}}</a>
